import React, { useMemo, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import ModalPopup from "../../../../components/ui/ModalPopup";
import BulkUploadModalContent from "../../BulkUploadModalContent";
import AddMoreDocumentForm from "../../AddMoreDocumentForm";
import AccountAggregatorModal from "../../AccountAggregatorModal";
import OtpInputForm from "../../OtpInputForm";
import { DocumentPreviewModal } from "./DocumentPreviewModal";
// import { CoApplicantDialog } from "./CoApplicantDialog";
import { FILE_INPUT_ACCEPT } from "../constants";
import { RootState } from "../../../../services/redux/store";
import { useSelector } from "react-redux";

type Props = {
  isXsOrSm: boolean;
  tabIndex: number;
  applicants: string[];
  applicationNumber: any;

  bulk: any;
  documents: any;
  preview: any;
  upload: any;
  coApplicant: any;

  isAddMoreModalOpen: boolean;
  setIsAddMoreModalOpen: (v: boolean) => void;
  modelType: string;
  setModelType: (v: string) => void;

  isAccountAggregatorModalOpen: boolean;
  setIsAccountAggregatorModalOpen: (v: boolean) => void;
  hideAccountAggregator?: boolean;
};

export function ApplicantTabsModals({
  isXsOrSm,
  tabIndex,
  applicants,
  applicationNumber,
  bulk,
  documents,
  preview,
  upload,
  coApplicant,
  isAddMoreModalOpen,
  setIsAddMoreModalOpen,
  modelType,
  setModelType,
  isAccountAggregatorModalOpen,
  setIsAccountAggregatorModalOpen,
  hideAccountAggregator = false,
}: Props) {
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity?: "error" | "success";
  }>({ open: false, message: "", severity: "error" });

  const partnerStartedJourney = useSelector((state: RootState) => state?.stepper?.partnerStartedJourney);

  const coApps = useMemo(() => {
    if(coApplicant.coApplicantFields) {
      const arr = coApplicant.coApplicantFields.filter((field: any) => String(field.name).includes("basic"));
      return arr;    
    }
    return []
  }, [coApplicant.coApplicantFields])

  return (
    <>
      <ModalPopup
        isOpen={bulk.isBulkUploadModalOpen}
        onClose={bulk.closeBulkUploadModal}
        title="Upload Bulk Documents"
      >
        <BulkUploadModalContent
          onCancel={bulk.closeBulkUploadModal}
          onContinue={bulk.handleContinueBulkUpload}
          tabIndex={tabIndex}
          handleDocCount={bulk.handleDocCount}
          setSnackbar={setSnackbar}
          partnerStartedJourney={partnerStartedJourney}
        />
      </ModalPopup>

      <ModalPopup
        isOpen={isAddMoreModalOpen}
        onClose={() => {
          setIsAddMoreModalOpen(false);
          documents.setDocumentCategoryId(0);
          setModelType("");
        }}
        title="Add More Documents"
      >
        <AddMoreDocumentForm
          onClose={() => {
            setIsAddMoreModalOpen(false);
            documents.setDocumentCategoryId(0);
            setModelType("");
          }}
          tabIndex={tabIndex}
          modelType={modelType}
          documentCategories={documents.documentCategories}
          documentCategoryId={documents.documentCategoryId}
          masterDocumentList={documents.masterDocumentList}
          applicants={applicants}
          documentData={documents.documentData}
          hasNotRequiredDocument={documents.hasNotRequiredDocument}
          setDocumentData={documents.setDocumentData}
          handleGetMasterDocumentList={documents.handleGetMasterDocumentList}
          getDocumentCategoriesViaAPI={documents.getDocumentCategoriesViaAPI}
        />
      </ModalPopup>

      <DocumentPreviewModal
        open={preview.isPreviewOpen}
        onClose={preview.closePreview}
        isXsOrSm={isXsOrSm}
        viewDocUrl={preview.viewDocUrl}
        viewDocMimeType={preview.viewDocMimeType}
      />

      {!hideAccountAggregator && isAccountAggregatorModalOpen && (
        <AccountAggregatorModal
          isAccountAggregatorModalOpen={isAccountAggregatorModalOpen}
          setIsAccountAggregatorModalOpen={setIsAccountAggregatorModalOpen}
          applicationNumber={applicationNumber}
          tabIndex={tabIndex}
          applicants={applicants}
        />
      )}

      {/* <CoApplicantDialog
        open={coApplicant.isCoApplicantModalOpen}
        onClose={coApplicant.handleCloseCoApplicantModal}
        getInitialValues={coApplicant.getInitialValues}
        validationSchema={coApplicant.coApplicantValidationSchema}
        onSubmit={coApplicant.handleAddCoApplicantFields}
        coApplicantFieldsLoading={coApplicant.coApplicantFieldsLoading}
        coApplicantFields={coApps}
        handleCoApplicantFormChange={coApplicant.handleCoApplicantFormChange}
        handlePanVerification={coApplicant.handlePanVerification}
        isPanVerified={coApplicant.isPanVerified}
        isCoApplicantPanVerified={coApplicant.isCoApplicantPanVerified}
        coApplicantPanLoading={coApplicant.coApplicantPanLoading}
        nextCoApplicantNum={coApplicant.coApplicantNumbers}
        empTypeError={coApplicant.empTypeError}
        setEmpTypeError={coApplicant.setEmpTypeError}
      /> */}

      <ModalPopup
        isOpen={coApplicant.isPanOtpModalOpen}
        onClose={coApplicant.handleClosePanOtpModal}
        title=""
        isOtpModal={true}
      >
        <OtpInputForm
          mobileMasked={(coApplicant.coApplicantFormData.mobileNumber || "").replace(
            /.(?=.{4})/g,
            "x"
          )}
          onOtpSubmit={coApplicant.handlePanOtpSubmit}
          onResendOtp={coApplicant.handleResendPanOtp}
        />
      </ModalPopup>

      <input
        type="file"
        accept={FILE_INPUT_ACCEPT}
        style={{ display: "none" }}
        ref={upload.fileInputRef}
        onChange={upload.handleFileChange}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

